import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/s3',
      name: 's3',
      component: () => import(/* webpackChunkName: "about" */ './views/S3.vue')
    },
    {
      path: '/s4',
      name: 's4',
      component: () => import(/* webpackChunkName: "about" */ './views/S4.vue')
    },
    {
      path: '/s5',
      name: 's5',
      component: () => import(/* webpackChunkName: "about" */ './views/S5.vue')
    },
  ]
})
